export default __webpack_public_path__ + "static/media/femimed_gabinet_2.967eeb7d.webp";